module.exports = __webpack_public_path__ + "static/img/social_widget_1.903d980.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/social_widget_1.png
// module id = +8o2
// module chunks = 11